import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type CompaniesByIdsAdminPayload,
  type CompaniesByIdsAdminResponse,
} from './types';
import {
  zodCompaniesByIdsAdminPayloadSchema,
  zodCompaniesByIdsAdminResponseSchema,
} from './validations';

/**
 * Fetches admin company summaries for the supplied company IDs.
 *
 * @param payload - Company IDs to resolve.
 * @param options - Optional request options, such as an abort signal.
 * @returns Company summaries for known, accessible company IDs.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company
 */
export async function fetchCompaniesByIdsAdmin(
  { companyIds }: CompaniesByIdsAdminPayload,
  options?: KyRequestOptions,
) {
  const { companyIds: normalizedCompanyIds } =
    zodCompaniesByIdsAdminPayloadSchema.parse({ companyIds });

  if (!normalizedCompanyIds.length) {
    return [];
  }

  const response = await vestigasApi
    .post(ENDPOINT.COMPANY.QUERY_BY_IDS_ADMIN(), {
      json: { companyIds: normalizedCompanyIds },
      validate: {
        body: zodCompaniesByIdsAdminPayloadSchema,
        response: zodCompaniesByIdsAdminResponseSchema,
      },
      ...options,
    })
    .json<CompaniesByIdsAdminResponse>();

  return response.data;
}
